export default __webpack_public_path__ + "static/run-screen-b056cc8d7d5e8be81cd7545a96a9a9a0.webp";